import React from 'react';

import {
  SubscriptionPlan,
  SubscriptionPlans,
} from '@/components/SubscriptionCard/SubscriptionCard.utils';
import useMediaQuery from '@/Utils/useMediaQuery';

export const Info = ({
  plan,
  info,
  accentColor,
}: {
  plan: SubscriptionPlan;
  info: SubscriptionPlans[keyof SubscriptionPlans]['info'];
  accentColor: string;
}) => {
  const circleColor = plan === 'Free' ? 'bg-lightBlue' : accentColor;

  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <div
      className={`bg-bodyBg py-6 pl-6 pr-4 mb-5 rounded-lg text-customBlack ${!isMobile ? 'h-60' : ''} ${isMobile && plan === 'Free' ? '' : 'mt-10'}`}
    >
      <ul className='flex flex-col gap-3 font-bold text-14px'>
        {info.map((infoItem) => (
          <li key={infoItem.normal} className='flex items-center mr-3'>
            <span
              className={`${circleColor} rounded-full mr-3 flex-shrink-0`}
              style={{ width: 8, height: 8 }}
            />
            <span className={'leading-8'}>
              <span className={`${accentColor} bg-clip-text text-transparent`}>
                {infoItem.highlighted}
              </span>{' '}
              <span className='leading-9'>{infoItem.normal}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
